module.exports = __webpack_public_path__ + "img/31.0c7162ef.jpg";